export default __webpack_public_path__ + "static/media/tower.44f7c199.png";